import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tournamentNames: [],
  teamNames: [],
  gameTitles: [],
  isActive: false, // フィルターが有効かどうか
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      const { tournamentNames, teamNames, gameTitles } = action.payload;
      state.tournamentNames = tournamentNames || [];
      state.teamNames = teamNames || [];
      state.gameTitles = gameTitles || [];
      state.isActive = 
        (tournamentNames && tournamentNames.length > 0) ||
        (teamNames && teamNames.length > 0) ||
        (gameTitles && gameTitles.length > 0);
    },
    clearFilters: (state) => {
      state.tournamentNames = [];
      state.teamNames = [];
      state.gameTitles = [];
      state.isActive = false;
    },
    updateTournamentNames: (state, action) => {
      state.tournamentNames = action.payload;
      state.isActive = 
        state.tournamentNames.length > 0 ||
        state.teamNames.length > 0 ||
        state.gameTitles.length > 0;
    },
    updateTeamNames: (state, action) => {
      state.teamNames = action.payload;
      state.isActive = 
        state.tournamentNames.length > 0 ||
        state.teamNames.length > 0 ||
        state.gameTitles.length > 0;
    },
    updateGameTitles: (state, action) => {
      state.gameTitles = action.payload;
      state.isActive = 
        state.tournamentNames.length > 0 ||
        state.teamNames.length > 0 ||
        state.gameTitles.length > 0;
    },
  },
});

export const { 
  setFilters, 
  clearFilters, 
  updateTournamentNames, 
  updateTeamNames, 
  updateGameTitles 
} = filterSlice.actions;

export default filterSlice.reducer;
